document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-cosmo-hero]').forEach((root) => {
    const slides = [...root.querySelectorAll('[data-cosmo-slide]')];
    const dots = [...root.querySelectorAll('[data-cosmo-dot]')];
    if (slides.length < 2) return;
    let index = 0;
    let timer;

    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.toggleAttribute('hidden', i !== index);
      });
      dots.forEach((dot, i) => {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    };

    const restart = () => {
      const delay = Number(root.dataset.autoplay || 0);
      clearInterval(timer);
      if (delay > 0) timer = setInterval(() => show(index + 1), delay);
    };

    root.querySelector('[data-cosmo-prev]')?.addEventListener('click', () => {
      show(index - 1);
      restart();
    });
    root.querySelector('[data-cosmo-next]')?.addEventListener('click', () => {
      show(index + 1);
      restart();
    });
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        show(i);
        restart();
      });
    });
    restart();
  });

  document.querySelectorAll('[data-cosmo-tabs]').forEach((root) => {
    const tabs = [...root.querySelectorAll('[data-cosmo-tab]')];
    const panels = [...root.querySelectorAll('[data-cosmo-panel]')];
    const activate = (id) => {
      tabs.forEach((tab) => {
        const selected = tab.dataset.cosmoTab === id;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });
      panels.forEach((panel) => {
        panel.toggleAttribute('hidden', panel.dataset.cosmoPanel !== id);
      });
    };
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activate(tab.dataset.cosmoTab));
    });
  });
});
